import { render, staticRenderFns } from "./Missing.vue?vue&type=template&id=28d36db6&scoped=true&"
import script from "./Missing.vue?vue&type=script&lang=js&"
export * from "./Missing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d36db6",
  null
  
)

export default component.exports